import React from "react";
import Loading from "../../Components/Loading";
import { renderPrice } from "../../Utils/functions";
import { useBookMarks } from "./Hooks";
import { FaHeart } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
const BookMarKList = () => {
  const { data, loading, toggle, markLoading } = useBookMarks();
  if (loading) {
    return (
      <div className="row">
        <Loading count={4} col={12} />
      </div>
    );
  }
  if (data.data.length == 0) {
    return (
      <div id="book-mark-list mt-5">
        <div className="row mt-5">
          <p className="text-center mt-5">علاقه مندی یافت نشد</p>
        </div>
      </div>
    );
  }
  return (
    <div id="book-mark-list">
      <div className="row ">
        {data.data.map((item, key) => {
          return (
            <div className="col-lg-6  card p-card" key={key}>
              <div className="row">
                <div className="col-sm-5 col-md-4">
                  <div className="position-relative h-sm-100">
                    <a
                      className="d-block h-100"
                      href="../../../app/e-commerce/product/product-details.html"
                    >
                      <img
                        className="img-fluid fit-cover w-sm-100 h-sm-100 rounded-1 absolute-sm-centered"
                        src={item?.main_image?.url}
                        alt
                      />
                    </a>
                  </div>
                </div>
                <div className="col-sm-7 col-md-8">
                  <div className="row align-items-stretch">
                    <div className="col-lg-8">
                      <h5 className="mt-3 mt-sm-0">
                        <Link
                          className="text-dark fs-0 fs-lg-1"
                          href="../../../app/e-commerce/product/product-details.html"
                          to={`/ads/${item?.city?.slug}/${item.slug}`}
                        >
                          {item?.title}
                        </Link>
                      </h5>
                      <p className="fs--1 mb-2 mb-md-3">
                        <a className="text-500" href="#!">
                          {item?.category?.title}
                        </a>
                      </p>
                    </div>
                    <div className="col-lg-4 d-flex justify-content-between flex-column">
                      <div>
                        <h4 className="fs-1 fs-md-2 text-warning mb-0">
                          {renderPrice(item?.price)}
                        </h4>
                      </div>
                      <div className="mt-2">
                        <button
                          onClick={() => toggle(item.id)}
                          className="btn btn-sm btn-outline-danger border-300 d-lg-block me-2 me-lg-0"
                        >
                          {loading ? (
                            <Spinner size="sm" />
                          ) : (
                            <>
                              <span
                                className="ms-2 d-none d-md-inline-block"
                                style={{ marginRight: "10px" }}
                              >
                                حذف
                              </span>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BookMarKList;
